export interface FrameScoreBreakdown {
  blur: number;
  glare: number;
  exposure: number;
  contrast: number;
  geometry: number;
  final: number;
  hardReject: boolean;
  hardRejectReason?: string;
}

// Weights must sum to 1.0.
const WEIGHTS = {
  blur: 0.25,
  glare: 0.2,
  exposure: 0.15,
  contrast: 0.15,
  geometry: 0.25,
} as const;

/**
 * Combines per-dimension quality scores into a single weighted confidence value.
 * Hard rejects (blur, glare) are tracked separately so they can block capture
 * even when the soft score is acceptable.
 */
export function scoreFrame(p: {
  blurScore: number;
  isTooBlurred: boolean;
  glareScore: number;
  isGlareSevere: boolean;
  exposureScore: number;
  contrastScore: number;
  geometryScore: number;
}): FrameScoreBreakdown {
  const {
    blurScore,
    isTooBlurred,
    glareScore,
    isGlareSevere,
    exposureScore,
    contrastScore,
    geometryScore,
  } = p;

  const hardReject = isTooBlurred || isGlareSevere;
  const hardRejectReason = isTooBlurred
    ? "image too blurry"
    : isGlareSevere
      ? "severe glare over MRZ"
      : undefined;

  const final =
    blurScore * WEIGHTS.blur +
    glareScore * WEIGHTS.glare +
    exposureScore * WEIGHTS.exposure +
    contrastScore * WEIGHTS.contrast +
    geometryScore * WEIGHTS.geometry;

  if (process.env.NODE_ENV !== "production") {
    // console.debug(
    //   `[scoreFrame] blur:${blurScore.toFixed(2)} glare:${glareScore.toFixed(2)} ` +
    //     `exp:${exposureScore.toFixed(2)} cont:${contrastScore.toFixed(2)} ` +
    //     `geo:${geometryScore.toFixed(2)} → final:${final.toFixed(2)}` +
    //     (hardReject ? ` HARD-REJECT(${hardRejectReason})` : ""),
    // );
  }

  return {
    blur: blurScore,
    glare: glareScore,
    exposure: exposureScore,
    contrast: contrastScore,
    geometry: geometryScore,
    final,
    hardReject,
    hardRejectReason,
  };
}
